//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import {
  useFetchTicketChildrenQuery,
} from 'api/tickets'

import { RouteTicketingSystemsTicket } from 'routes'

import colors from 'components/utils/colors'
import TableRow from 'components/Shared/TableNew/TableRow'
import TableCell from 'components/Shared/TableNew/TableCell'
import Spinner from 'components/Shared/Spinner/Index'
import TableCells from './TableCells'

const MatchInfoTableCell = styled(TableCell)`
  background-color: ${colors.secondary90};
`

const SpinnerWrapper = styled.div`
  display: flex;
  padding-left: 12px;
`

const ExpandedRowChildren = ({ ticket, ticketingSystem, ticketBonding }) => {
  const { t } = useTranslation()
  const { data, isFetching } = useFetchTicketChildrenQuery({
    ticketingSystemDisplayId: ticketingSystem.displayId,
    parentTicketId: ticket.id,
    perPage: 50,
  })

  const tickets = data?.tickets || []
  const partnerStatusesMap = data?.partnerStatusesMap || {}

  if (isFetching) {
    return (
      <TableRow key={`fetching_${ticket.id}`} hoverable={false} clickable={false}>
        <MatchInfoTableCell colSpan='100%'>
          <SpinnerWrapper>
            {t('common.loading')}
            <Spinner size={16} />
          </SpinnerWrapper>
        </MatchInfoTableCell>
      </TableRow>
    )
  }

  return (
    <>
      {tickets.map(ticket => {
        const statusName = ticket.status
        const statusColor = partnerStatusesMap[statusName]?.color

        const ticketUrl = RouteTicketingSystemsTicket({
          ticketingSystemDisplayId: ticketingSystem.displayId,
          ticketId: ticket.externalId,
        })

        return (
          <TableRow
            key={ticket.id}
            color={statusColor}
          >
            <TableCells
              ticket={ticket}
              ticketUrl={ticketUrl}
              partnerStatusesMap={partnerStatusesMap}
              ticketBonding={ticketBonding}
              withExpandableRows={false}
              isInChildRow
            />
          </TableRow>
        )
      })}
    </>
  )
}

ExpandedRowChildren.propTypes = {
  ticket: PropTypes.object.isRequired,
  ticketingSystem: PropTypes.object.isRequired,
  ticketBonding: PropTypes.string,
}

export default ExpandedRowChildren
